import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { basePlanningBoardActions, basePlanningBoardSelectors, BaseCoreState } from '../../../_store';
import { BasePlanningBoardFiltersService } from '../_services/base-planning-board-filters.service';
import { BaseListFilterMemoryService } from '../../../shared/services/base-list-filter-memory.service';

@Injectable({ providedIn: 'root' })
export class BasePlanningBoardListGuard {
  constructor(
    private readonly store: Store<BaseCoreState>,
    private readonly filtersService: BasePlanningBoardFiltersService,
    private readonly router: Router,
    private readonly listFilterMemory: BaseListFilterMemoryService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | UrlTree {
    const routeKey = state.url.split('?')[0];

    // Entering with no active filters: restore the last remembered selection (if any)
    // by redirecting to the same URL with those filters, so the board loads filtered.
    if (!Object.keys(this.filtersService.pickFilterParams(route.queryParams)).length) {
      const snapshot = this.listFilterMemory.getSnapshot(routeKey);
      if (snapshot && Object.keys(snapshot).length) {
        const tree = this.router.parseUrl(state.url);
        tree.queryParams = { ...tree.queryParams, ...snapshot };
        return tree;
      }
    }

    this.store.dispatch(
      basePlanningBoardActions.loadPlanningBoardList({
        payload: this.filtersService.toApiPayload(route.queryParams),
      })
    );

    return this.store.select(basePlanningBoardSelectors.getPlanningBoardList).pipe(
      filter((response) => response.ok !== undefined),
      map((response) => !!response.ok)
    );
  }
}
